import { McAction } from '../IMcAction';
import initialState, { IQcPlanDetailOptionState } from '../modules/qc-plan/IQcPlanDetailOptionState';
import { GET_QC_PLAN_DETAIL_OPTION } from '../modules/qc-plan/qc-plan.action.const';
import { getQcPlanDetailOptionState } from '../modules/qc-plan/qc-plan.reducer.logic';

export function qcPlanDetailOptionReducer(state: IQcPlanDetailOptionState = initialState, action: McAction) {
    switch (action.type) {
        case GET_QC_PLAN_DETAIL_OPTION:
            return getQcPlanDetailOptionState(state, action);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/reducers/qc-plan-detail-option.reducer.ts